export enum SSHKeyMeta {
  MODEL = "sshkey",
  PK = "id",
}
